import React from 'react';
import { Modal, Header, Button } from 'semantic-ui-react';
import './ConfirmActionModalComponent.css';

/**
 * ConfirmActionModalComponent is a reusable two-action confirmation dialog,
 * built on plain Semantic UI Modal/Button (same as the app's logout confirmation
 * modal) so it keeps Semantic UI's default sizing and the divider border/background
 * above the action buttons, with its own scoped classes for the button colors.
 * @param {boolean} open - Whether the modal is visible.
 * @param {function} onClose - Called when the modal is dismissed (backdrop click / escape key).
 * @param {string} title - Modal title.
 * @param {string|node} message - Modal body message.
 * @param {string} primaryText - Label for the non-destructive (safe) action button.
 * @param {function} onPrimaryClick - Handler for the primary action button.
 * @param {string} secondaryText - Label for the destructive action button.
 * @param {function} onSecondaryClick - Handler for the destructive action button.
 * @param {boolean} secondaryLoading - Disables both buttons and swaps the destructive button's label.
 * @param {string} secondaryLoadingText - Label shown on the destructive action while secondaryLoading is true.
 * @param {string} size - Semantic UI modal size.
 * @param {string} dataCy - Prefix used for the data-cy attributes on the action buttons.
 **/
const ConfirmActionModalComponent = ({
  open,
  onClose,
  title,
  message,
  primaryText = 'Continue',
  onPrimaryClick,
  secondaryText = 'Delete',
  onSecondaryClick,
  secondaryLoading = false,
  secondaryLoadingText = 'Deleting...',
  size = 'tiny',
  dataCy = 'confirm-action',
}) => {
  return (
    <Modal open={open} onClose={onClose} size={size} className="confirm-action-modal">
      <Modal.Content>
        <Header as="h3">{title}</Header>
        <p style={{ textAlign: 'center' }}>{message}</p>
      </Modal.Content>
      <Modal.Actions>
        <Button
          className="confirm-action-modal-btn-primary"
          onClick={onPrimaryClick}
          disabled={secondaryLoading}
          data-cy={`${dataCy}-primary-btn`}
        >
          {primaryText}
        </Button>
        <Button
          className="confirm-action-modal-btn-danger"
          onClick={onSecondaryClick}
          disabled={secondaryLoading}
          data-cy={`${dataCy}-secondary-btn`}
        >
          {secondaryLoading ? secondaryLoadingText : secondaryText}
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default ConfirmActionModalComponent;
